import { useSearchParams } from 'react-router-dom';
import { formatedColor } from '../helpers/colors';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    carousel: searchParams.get('carousel') || '0',
    user: searchParams.get('user') || '75768268519',
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    period: searchParams.get('period')
      ? parseInt(searchParams.get('period') || '')
      : 600,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    startFrom: parseInt(searchParams.get('startFrom') || '') || 1,
    bg: searchParams.get('bg') || null,
    scrollSpeed: searchParams.get('scrollSpeed')
      ? Number(searchParams.get('scrollSpeed'))
      : 3000,
    scrollDelay: searchParams.get('scrollDelay')
      ? Number(searchParams.get('scrollDelay'))
      : 2000,
    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    qrCode: searchParams.get('qrCode'),
    phoneNumber,

    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrTitle2: searchParams.get('qrTitle2'),

    voteCounter: searchParams.get('voteCounter'),
    // --------------------------------------------------
    // таймер обратного отсчета
    // --------------------------------------------------
    voteTimer: searchParams.get('voteTimer'),
    // --------------------------------------------------
    // параметры цветов
    // анонс
    // --------------------------------------------------
    titleTextColor: formatedColor(
      searchParams.get('titleTextColor') || '2a2d32'
    ),
    phoneTextColor: formatedColor(
      searchParams.get('phoneTextColor') || '2a2d32'
    ),
    // --------------------------------------------------
    // вопрос
    // --------------------------------------------------
    qwestTextColor: formatedColor(searchParams.get('qwestTextColor') || 'fff'),

    qwestBgColorStart: formatedColor(
      searchParams.get('qwestBgColorStart') || '3346d3'
    ),
    qwestBgColorStop: formatedColor(
      searchParams.get('qwestBgColorStop') || '32d9ff'
    ),
    qwestColorDirection: searchParams.get('qwestColorDirection') || '-91',
    // --------------------------------------------------
    // варианты ответа
    // --------------------------------------------------
    variantNumTextColor: formatedColor(
      searchParams.get('variantNumTextColor') || '161616'
    ),
    variantNumShadowColor: formatedColor(
      searchParams.get('variantNumShadowColor') || '356ddf'
    ),
    variantTextColor: formatedColor(
      searchParams.get('variantTextColor') || '161616'
    ),
    // --------------------------------------------------
    // стадия с процентами
    // --------------------------------------------------
    variantBarBgColorStart: formatedColor(
      searchParams.get('variantBarBgColorStart') || 'ffa05c'
    ),
    variantBarBgColorStop: formatedColor(
      searchParams.get('variantBarBgColorStop') || 'fe7f62'
    ),
    variantBarColorDirection:
      searchParams.get('variantBarColorDirection') || '-180',

    variantPersentTextColor: formatedColor(
      searchParams.get('variantPersentTextColor') || '28364e'
    ),
    // --------------------------------------------------
    // сообщение
    // --------------------------------------------------
    msgAvatarShadowColor: formatedColor(
      searchParams.get('msgAvatarShadowColor') || 'fe8960'
    ),
    msgNameTextColor: formatedColor(
      searchParams.get('msgNameTextColor') || 'fff'
    ),

    msgNameBgColorStart: formatedColor(
      searchParams.get('msgNameBgColorStart') || '3346d3'
    ),
    msgNameBgColorStop: formatedColor(
      searchParams.get('msgNameBgColorStop') || '32d9ff'
    ),
    msgNameColorDirection: searchParams.get('msgNameColorDirection') || '-91',

    msgContentTextColor: formatedColor(
      searchParams.get('msgContentTextColor') || '2a2d32'
    ),
    // --------------------------------------------------
    // заголовок счетчика "проголосовало"
    // --------------------------------------------------
    counterBgColorStart: formatedColor(
      searchParams.get('counterBgColorStart') || 'fe7963'
    ),
    counterBgColorStop: formatedColor(
      searchParams.get('counterBgColorStop') || 'ffa05c'
    ),
    counterColorDirection: searchParams.get('counterColorDirection') || '-180',
    // --------------------------------------------------
    // цветные большие круги
    // --------------------------------------------------
    circleTopBgColorStart: formatedColor(
      searchParams.get('circleTopBgColorStart') || 'fd6567'
    ),
    circleTopBgColorStop: formatedColor(
      searchParams.get('circleTopBgColorStop') || 'ffaf59'
    ),
    circleTopColorDirection: searchParams.get('circleTopColorDirection') || '2',

    circleBottomBgColorStart: formatedColor(
      searchParams.get('circleBottomBgColorStart') || '3346d3'
    ),
    circleBottomBgColorStop: formatedColor(
      searchParams.get('circleBottomBgColorStop') || '3bdaff'
    ),
    circleBottomColorDirection:
      searchParams.get('circleBottomColorDirection') || '2',
    // --------------------------------------------------
    // маленькие цветные круги
    // --------------------------------------------------
    firstSmallCircleBgColor: formatedColor(
      searchParams.get('firstSmallCircleBgColor') || 'e95e60'
    ),
    secondSmallCircleBgColor: formatedColor(
      searchParams.get('secondSmallCircleBgColor') || '3796eb'
    ),
    thirdSmallCircleBgColor: formatedColor(
      searchParams.get('thirdSmallCircleBgColor') || 'fe8960'
    ),
  };
};
